
import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import MenuPersonasSSV from './MenuPersonasSSV';
import { useAuth } from '../../Auth/AuthContext';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { FaSave, FaArrowAltCircleRight } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import CargandoSpinner from '../Utils/CargandoSpinner';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
function CalcularEdad(date){
    return moment().diff(date, 'years');
}
export default function SSVPerfilProductivo() {
    const { token } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [edad, setEdad] = useState('');
    const [capacidades, setCapacidades] = useState([]);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    
    const fetchData = async (idPersona, idEncuesta) => {
        let url = `/encuestassv/perfilproductivo/crearformularioperfilproductivo`;
        let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.datosPerfilProductivo);
            setCapacidades(result.capacidades || []);
            console.log('Datos de perfil productivo obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos básicos de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
    
    useEffect(() => {
        fetchData(idPersona, idEncuesta);
    }, [idPersona, idEncuesta]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function GuardarDatosPerfilProductivo() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/perfilproductivo/guardardatosperfilproductivo`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de perfil productivo de la persona.');
            }
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de perfil productivo de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }
    
    const resetForm = (data) => {
        if (data) {
            reset((prevValues) => ({
                ...prevValues,
                id: data.id || '',
                cons_ficha_id: data.cons_ficha_id || '',
                nombre: data.nombre || '',
                edad_calculada: data.edad_calculada || '',
                perfil_productivo_24_meses_tomado_curso: data.perfil_productivo_24_meses_tomado_curso || 0,
                perfil_productivo_cual_curso: data.perfil_productivo_cual_curso || '',
                perfil_productivo_capacidades_potencialidades: data.perfil_productivo_capacidades_potencialidades || '',
                perfil_productivo_capacidades_potencialidades_cual: data.perfil_productivo_capacidades_potencialidades_cual || '',
                perfil_productivo_tiene_o_espera_negocio: data.perfil_productivo_tiene_o_espera_negocio || 0,
                perfil_productivo_tiene_o_espera_negocio_cual: data.perfil_productivo_tiene_o_espera_negocio_cual || '',
                perfil_productivo_tipo_de_idea_negocio: data.perfil_productivo_tipo_de_idea_negocio || 0,
                perfil_productivo_registro_negocio: data.perfil_productivo_registro_negocio || 0,
                perfil_productivo_registro_negocio_cual: data.perfil_productivo_registro_negocio_cual || '',
                perfil_productivo_cuanto_tiempo_funciona: data.perfil_productivo_cuanto_tiempo_funciona || 0,
                perfil_productivo_recibio_apoyo_negocio: data.perfil_productivo_recibio_apoyo_negocio || 0,
                perfil_productivo_recibio_apoyo_negocio_quien: data.perfil_productivo_recibio_apoyo_negocio_quien || '',
                perfil_productivo_recibio_financiamiento_negocio: data.perfil_productivo_recibio_financiamiento_negocio || 0,
                perfil_productivo_cual_financiamiento: data.perfil_productivo_cual_financiamiento || '',
                perfil_productivo_dificultades_negocio_falta_capital: data.perfil_productivo_dificultades_negocio_falta_capital || 0,
                perfil_productivo_dificultades_negocio_poca_informacion: data.perfil_productivo_dificultades_negocio_poca_informacion || 0,
                perfil_productivo_dificultades_negocio_miedo_fracaso: data.perfil_productivo_dificultades_negocio_miedo_fracaso || 0,
                perfil_productivo_dificultades_negocio_no_asesoria: data.perfil_productivo_dificultades_negocio_no_asesoria || 0,
                perfil_productivo_dificultades_negocio_sin_personal: data.perfil_productivo_dificultades_negocio_sin_personal || 0,
                perfil_productivo_dificultades_negocio_problemas_seguridad: data.perfil_productivo_dificultades_negocio_problemas_seguridad || 0,
                perfil_productivo_dificultades_negocio_falta_local: data.perfil_productivo_dificultades_negocio_falta_local || 0,
                perfil_productivo_dificultades_negocio_otra: data.perfil_productivo_dificultades_negocio_otra || '',
            }))
            setEdad(CalcularEdad(data.datos_basicos_fecha_nacimiento));
        }
    }
    
  
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas perfil productivo</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Perfil Productivo</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idEncuesta={idEncuesta} idPersona={idPersona}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosPerfilProductivo)}>
                        <Card>
                            <CardHeader>
                                <h2>Para cada integrante de la familia</h2>
                                <b>Aplica para todas las personas de 18 años en adelante.</b>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                    <Form.Group>
                                        <label htmlFor="id">id</label>
                                        <Form.Control readOnly id="id" placeholder="id" type="text" {...register("id")} />
                                    </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                    <Form.Group>
                                        <label htmlFor="nombre">Nombre de la persona</label>
                                        <Form.Control readOnly id="nombre" placeholder="Nombre" type="text" {...register("nombre")} />
                                    </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                    <Form.Group>
                                        <label htmlFor="edad">Edad</label>
                                        <Form.Control readOnly id="edad" placeholder="Edad" type="text" value={edad} />
                                    </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                    <Form.Group>
                                        <Form.Label>1. Ademas de la información reportada sobre educación. En los últimos 24 meses ¿ha tomado o está tomando algún curso de formación para el trabajo?</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_24_meses_tomado_curso" style={{width: "100%"}}  {...register("perfil_productivo_24_meses_tomado_curso")} >
                                        <option value="0" ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. NS/NR</option>
                                        </Form.Control>
                                        <Form.Control id="perfil_productivo_cual_curso" placeholder="Cual?" type="text" {...register("perfil_productivo_cual_curso")} />
                                    </Form.Group>
                                    </Col>
                                    <Col md={8}>  
                                        <div className="form-group">
                                            <Form.Label>2. Capacidades y potencialidades ¿Tiene conocimientos o habilidades en alguno de los siguientes oficios?</Form.Label>
                                            
                                            <Form.Check type="checkbox" id="chkcapacidadessi" />
                                            <Form.Label> Si</Form.Label>
                                            
                                            <div id="divCapaci">
                                                <Button variant="primary" onClick={handleShow}>
                                                    Seleccionar capacidades y potencialidades
                                                </Button>
                                                <Modal show={show} onHide={handleClose}>
                                                    <Modal.Header closeButton>
                                                    <Modal.Title>2. Capacidades y potencialidades</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p>Para seleccionar varios elementos presione la tecla ctrl + clic</p>
                                                        <Form.Control as="select" id="slcpot" className="form-control" multiple data-placeholder="Capacidades" size="20" style={{width: "100%"}} tabIndex="-1" >
                                                            <option hidden value="0"></option>
                                                            {capacidades.map((capacidad) => (
                                                                <option key={capacidad.id} value={capacidad.id}>{capacidad.str_capacidad}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                    <Button variant="secondary" onClick={handleClose}>
                                                        Cerrar
                                                    </Button>
                                                    <Button variant="primary" onClick={handleClose}>
                                                        Listo
                                                    </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Form.Control as="textarea" readOnly id="perfil_productivo_capacidades_potencialidades" className="form-control" rows="3" placeholder="Capacidades y potencialidades" {...register("perfil_productivo_capacidades_potencialidades")}></Form.Control>
                                                <div>
                                                    <Form.Label>Otro, Cual?</Form.Label>
                                                    <Form.Control type="text" id="perfil_productivo_capacidades_potencialidades_cual" placeholder="Otro, Cual?" {...register("perfil_productivo_capacidades_potencialidades_cual")} />
                                                </div>
                                            </div>
                                            <Form.Check type="checkbox" id="chkcapacidadesno" />
                                            <Form.Label> No</Form.Label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>3. ¿Tiene un negocio o dentro de sus expectativas está la conformacion de un negocio?</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_tiene_o_espera_negocio" style={{width: "100%"}}  {...register("perfil_productivo_tiene_o_espera_negocio")} >
                                        <option value="0" ></option>
                                        <option value="1">1. Si, Cual?</option>
                                        <option value="2">2. No (Pase a "Vivienda")</option>
                                        </Form.Control>
                                        <Form.Control id="perfil_productivo_tiene_o_espera_negocio_cual" placeholder="Cual" type="text" {...register("perfil_productivo_tiene_o_espera_negocio_cual")} />
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>4. Actualmente tiene:</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_tipo_de_idea_negocio" style={{width: "100%"}}  {...register("perfil_productivo_tipo_de_idea_negocio")} >
                                        <option value="0" ></option>
                                        <option value="1">1. Idea de negocio (Pase a pregunta 7)</option>
                                        <option value="2">2. Proyecto de negocio formulado</option>
                                        <option value="3">3. Negocio funcionando</option>
                                        <option value="4">4. Ninguna de las anteriores (Pase a "Vivienda")</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>5. ¿Ha registrado el negocio ante alguna entidad?</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_registro_negocio" style={{width: "100%"}}  {...register("perfil_productivo_registro_negocio")} >
                                        <option value="0" ></option>
                                        <option value="1">1. Si, Cual?</option>
                                        <option value="2">2. No (Pase a pregunta 5)</option>
                                        </Form.Control>
                                        <Form.Control id="perfil_productivo_registro_negocio_cual" placeholder="Entidad" type="text" {...register("perfil_productivo_registro_negocio_cual")} />
                                    </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>6. ¿Hace cuanto tiempo que funciona el negocio?</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_cuanto_tiempo_funciona" style={{width: "100%"}}  {...register("perfil_productivo_cuanto_tiempo_funciona")}>
                                        <option value="0" ></option>
                                        <option value="1">1. Menos de 1 año</option>
                                        <option value="2">2. 1 -2 años</option>
                                        <option value="3">3. 3 - 5 años</option>
                                        <option value="4">4. Más de 5 años</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>7. ¿Ha recibido algun tipo de apoyo a emprendimiento y/o fortalecimiento para su unidad productiva (diferente a financiamiento)?</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_recibio_apoyo_negocio" style={{width: "100%"}}  {...register("perfil_productivo_recibio_apoyo_negocio")}>
                                        <option value="0" ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <Form.Control id="perfil_productivo_recibio_apoyo_negocio_quien" placeholder="¿De quién?" type="text" {...register("perfil_productivo_recibio_apoyo_negocio_quien")} />
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>8. ¿Ha recibido financiamiento para emprendimiento y/o fortalecimiento para su unidad productiva en las siguientes modalidades</Form.Label>
                                        <Form.Control as="select" id="perfil_productivo_recibio_financiamiento_negocio" style={{width: "100%"}}  {...register("perfil_productivo_recibio_financiamiento_negocio")}>
                                        <option value="0" ></option>
                                        <option value="1">1. Crédito con entidad financiera</option>
                                        <option value="2">2. Crédito con agiotista o paga diario</option>
                                        <option value="3">3. Recursos propios</option>
                                        <option value="4">4. Créditos con fondos de emprendimiento</option>
                                        <option value="5">5. Donaciones</option>
                                        <option value="6">6. Subsidios</option>
                                        <option value="7">7. Otros</option>
                                        <option value="8">8. Ninguna</option>
                                        <option value="9">9. No necesita financiamiento</option>
                                        </Form.Control>
                                        <Form.Control id="perfil_productivo_cual_financiamiento" placeholder="Cual?" type="text" {...register("perfil_productivo_cual_financiamiento")} />
                                    </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Label>9. ¿Cuáles han sido las dos principales dificultades que ha tenido para desarollar el negocio? (Selección múltiple)</Form.Label>
                                        <Row>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_falta_capital" type="checkbox" label="1. Falta de capital" {...register("perfil_productivo_dificultades_negocio_falta_capital")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_poca_informacion" type="checkbox" label="2. Poca información" {...register("perfil_productivo_dificultades_negocio_poca_informacion")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_miedo_fracaso" type="checkbox" label="3. Miedo al fracaso" {...register("perfil_productivo_dificultades_negocio_miedo_fracaso")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_no_asesoria" type="checkbox" label="4. No cuenta con asesoria" {...register("perfil_productivo_dificultades_negocio_no_asesoria")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_sin_personal" type="checkbox" label="5. No tiene personal" {...register("perfil_productivo_dificultades_negocio_sin_personal")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_problemas_seguridad" type="checkbox" label="6. Problemas de seguridad" {...register("perfil_productivo_dificultades_negocio_problemas_seguridad")} />
                                            </Col>
                                            <Col md={12}>
                                                <Form.Check id="perfil_productivo_dificultades_negocio_falta_local" type="checkbox" label="7. Falta de local" {...register("perfil_productivo_dificultades_negocio_falta_local")} />
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <p>8. Otra</p>
                                                    <Form.Control className="form-control" id="perfil_productivo_dificultades_negocio_otra" placeholder="Cual?" type="text" {...register("perfil_productivo_dificultades_negocio_otra")} />
                                                </div>
                                            </Col>
                                        </Row>                                    
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type='submit' id="btnPersonaBasicosGuardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button 
                                        id="btnPersonaBasicosCancel" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }